module.exports = __webpack_public_path__ + "img/p3.8288a5d.png";